import { render, staticRenderFns } from "./ModelsTab.vue?vue&type=template&id=0dcd8648"
import script from "./ModelsTab.vue?vue&type=script&lang=ts"
export * from "./ModelsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports